module.exports = __webpack_public_path__ + "static/media/pensando.7c05b90e.svg";